import React from "react";
import Close from "../../../../../assets/customSVG/Close";
import Label from "../../commonComponents/label";
import FilterOperator from "./FilterOperator";
import {
  handleDeleteFilter,
  updateFilterOperator,
  updateFilterLogic,
} from "../../../../../reduxToolkit/crmSlice";
import { useDispatch } from "react-redux";
import AddIcon from "../../../../../assets/customSVG/AddIcon";
import { hexToRgba } from "../../../helpers";
import { getOperatorLabel } from "../../../constants";

const RenderFilters = ({
  filters,
  operator,
  setOperator = () => {},
  handleAddNewFilter = () => {},
  profileAttributes = [], // NEW: Profile attributes for display labels
}) => {
  const dispatch = useDispatch();

  const handleModalState = (operator = "and") => {
    setOperator((prev) => {
      return { operator, isModalOpen: !prev.isModalOpen };
    });
  };

  // NEW: Helper function to get display name for filters
  const getFilterDisplayName = (filterName) => {
    // Check if it's a profile attribute
    if (filterName?.startsWith('attr_')) {
      const attrId = parseInt(filterName.replace('attr_', ''));
      const attribute = profileAttributes.find(attr => attr.id === attrId);
      return attribute?.label || filterName;
    }

    // Return regular filter name (capitalized with spaces)
    return filterName?.charAt(0).toUpperCase() + filterName?.slice(1).replace(/_/g, ' ') || '';
  };
  return (
    <div className="flex gap-[.5vw] flex-wrap duration-200 max-h-fit">
      {filters?.map((filter, index) => {
        const { selectedFilter, selectedField, fieldValue } = filter?.value;
        return (
          <React.Fragment key={filter.id}>
            <div className="flex items-center">
              <div className="bg-gray-100 rounded-md ps-[.8vw] pe-[.4vw] py-[.2vw]- text-[.8vw] text-[#616874] flex gap-[.2vw] items-center">
                <div className="flex items-center gap-[.4vw]">
                  <span className="capitalize font-[500]">{getFilterDisplayName(selectedFilter)}</span>{" "}
                  <span>{getOperatorLabel(selectedField)}</span>{" "}
                  {Array.isArray(fieldValue) ? (
                    <div className="flex gap-[.4vw]">
                      {fieldValue.map((item) => {
                        return (
                          <Label
                            id={item.id}
                            key={item.id}
                            disableHover={true}
                            // labelClassNames={"text-gray-500"}
                            mainClassNames={"bg-white"}
                            color={item?.display_color}
                            style={{
                              backgroundColor: hexToRgba(
                                item?.display_color,
                                0.2
                              ),
                            }}
                            label={item?.tag}
                            closeColor="gray"
                            showClose={fieldValue?.length > 1}
                            closeAction={(_, label_id, e) => {
                              dispatch(
                                handleDeleteFilter({
                                  id: filter.id,
                                  remove_label: true,
                                  label_id,
                                })
                              );
                            }}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <span>{['is_true', 'is_false'].includes(selectedField) ? '': fieldValue}</span>
                  )}
                </div>
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    dispatch(handleDeleteFilter({ id: filter.id }));
                  }}
                >
                  <Close
                    width="30"
                    height="30"
                    strokeWidth="1.6"
                    stroke="#616874"
                    circle={false}
                  />
                </span>
              </div>
            </div>

            {/* Show AND/OR dropdown between filters, except after the last filter */}
            {index < filters.length - 1 && (
              <FilterOperator
                onClick={(e, ops) => {
                  dispatch(updateFilterLogic({ id: filter.id, logic: ops }));
                }}
                id={filter.id}
                selected={filter.logic || 'and'}
              >
                <div
                  className="bg-gray-100 duration-200 capitalize rounded-md overflow-hidden cursor-pointer text-[.8vw] flex items-center font-[500] px-[.5vw] ms-[.4vw]"
                >
                  {filter.logic || 'and'}
                </div>
              </FilterOperator>
            )}
          </React.Fragment>
        );
      })}
      <FilterOperator
        open={operator.isModalOpen}
        onOpenChange={() => handleModalState()}
        onClick={(_, ops) => {
          // handleClick();
          handleAddNewFilter();
          handleModalState(ops);
        }}
      >
        <span
          className={`bg-gray-100 rounded-md cursor-pointer duration-200  overflow-hidden ${
            filters.length ? "scale-100 h-fit" : "scale-0 h-0"
          }`}
        >
          <AddIcon stroke="#616874" strokeWidth={1.4} />
        </span>
      </FilterOperator>
    </div>
  );
};

export default RenderFilters;
